module.exports = __webpack_public_path__ + "img/course108.be96957c.png";